import { InjectionToken } from '@angular/core';
import { SmsRegistrationDependencies } from './interface';

export const SmsInjectionToken = new InjectionToken<SmsRegistrationDependencies>(
  'dependencies for the sms registration',
);

export const SmsTextLimitToken = new InjectionToken<number>('limits the allowable size of SMS text');
